import { render, staticRenderFns } from "./ModalSolicitacaoTipoLesaoQuantidade.vue?vue&type=template&id=77f1a085"
import script from "./ModalSolicitacaoTipoLesaoQuantidade.vue?vue&type=script&lang=ts"
export * from "./ModalSolicitacaoTipoLesaoQuantidade.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports